import React, {Component} from 'react';
import { AuthManager } from "./AuthManager"
import AuthenticationRedirectPage from "./AuthenticationRedirectPage"

class SilentCallbackHandler extends Component {
    componentDidMount(){
        let mgr = new AuthManager();
        mgr.signinSilentCallback()
        .then(_ => {
            console.log("Token refreshed");
        })
        .catch(err => {
            console.log(err);
        });
    }

    render () {
        return null;
    }
}

class SignInHandler extends Component {

    getParameterByName(name) {
        var urlParams = new URLSearchParams(window.location.search);
        return urlParams.has(name) ? urlParams.get(name) : '';
    }

    updateBrowserLocation(){
        let returnUrl = this.getParameterByName("redirect");

        window.history.replaceState({},
            window.document.title,
            window.location.origin);

        if(returnUrl)
            window.location = returnUrl;
        else
            window.location = "/";
    }

    componentDidMount(){
        let mgr = new AuthManager();
        mgr.signinRedirectCallback().then(() => {
            this.updateBrowserLocation();
            }, error => {
                console.error(error);
            });
    }

    render () {
        return null;
    }
}

function authComponent(WrappedComponent) {
    return class extends  Component{
        constructor(props){
            super(props);
            this._authManager = new AuthManager();
            this.state = {
                isAuthenticated: false
            }
        }

        componentDidMount() {
            this._authManager.getUser()
            .then(user => {
                this.setState({isAuthenticated: user != null});
                if(!user) this._authManager.login();
            })
            .catch(e => {
                console.log(e);
            });
        }

        render = () => (
            this.state.isAuthenticated ? 
            <WrappedComponent {...this.props} /> : 
            <AuthenticationRedirectPage/>)
    };
}

export {SignInHandler, SilentCallbackHandler, authComponent};



// WEBPACK FOOTER //
// ./src/components/Authentication/AuthComponent.js